import ProcessDetailsHeader from "./ProcessDetailsHeader";

export default ProcessDetailsHeader;